import React, {useEffect, useMemo, useState} from 'react';
import {
  type MRT_ColumnFiltersState,
  type MRT_PaginationState,
  type MRT_SortingState,
  MaterialReactTable,
  type MRT_ColumnDef,
  useMaterialReactTable,
} from 'material-react-table';
import {Box, Button, Dialog, DialogContent, Typography} from '@mui/material';
import { useGetAllMonitorProgettiNodi } from './Services';
import { MonitorProgettiNodi } from './types';


interface Props {
  codprogprop: string;
  desprogprop: string;
  onClose: () => void;
}



const ListaMonitorProgettiNodi: React.FC<Props> = ({ codprogprop, desprogprop, onClose }) => {

const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 100,
  });



  useEffect(() => {
  if (codprogprop) {
    setColumnFilters([{ id: 'CODPROG', value: codprogprop }]);
  }
}, [codprogprop]);


  const {
    data: { results = [], count = 0 } = {},
    isError,
    isFetching,
    isLoading,
  } = useGetAllMonitorProgettiNodi(pagination, columnFilters, globalFilter, sorting);

  const renderNumberWithHighlight = (rawValue: string) => {
    const value = parseFloat(rawValue.replace(',', '.'));
    return (
      <div
        style={{
          backgroundColor: value < 0 ? '#ffe5e5' : 'transparent',
          padding: '2px 4px',
          borderRadius: '4px',
          textAlign: 'right',
        }}
      >
        {rawValue}
      </div>
    );
  };


  const columns = useMemo<MRT_ColumnDef<MonitorProgettiNodi>[]>(
    () => [
      // { accessorKey: 'CODDITTA', header: 'Codditta', size: 1 },
      // { accessorKey: 'DESPROG', header: 'Desprog', size: 1 },
      // { accessorKey: 'DATAINIZIO', header: 'Datainizio', size: 1 },
      // { accessorKey: 'STATOPROG', header: 'Statoprog', size: 1 },
      // { accessorKey: 'CODPROG', header: 'Codprog', size: 1 },
      { accessorKey: 'CODNODO', header: 'Codnodo', size: 1 },
      { accessorKey: 'DESNODO', header: 'Desnodo', size: 1 },
      // { accessorKey: 'TIPONODO', header: 'Tiponodo', size: 1 },
      { accessorKey: 'OREORDNODO', header: 'OreLav', size: 1 },
      // { accessorKey: 'OREORDCONT', header: 'Oreordcont', size: 1 },
      // { accessorKey: 'OREORDPREV', header: 'Oreordprev', size: 1 },
      { accessorKey: 'ORECONT', header: 'OrePrep', size: 1 },
      { accessorKey: 'OREPREV', header: 'OreStima', size: 1 },
      // { accessorKey: 'OREORDASSTELNOCONTPREV', header: 'Oreordasstelnocontprev', size: 1 },
      // { accessorKey: 'RICAVI', header: 'Ricavi', size: 1 },
      // { accessorKey: 'DATAAGG', header: 'Dataagg', size: 1 },
      // { accessorKey: 'DATAGOLIVEPIAN', header: 'Datagolivepian', size: 1 },
      // { accessorKey: 'PERCOMP', header: 'Percomp', size: 1 },
      // { accessorKey: 'DATACOLL', header: 'Datacoll', size: 1 },
      { accessorKey: 'OREDIFF', header: 'OreDiff', size: 1,
      Cell: ({ cell }) => renderNumberWithHighlight(cell.getValue<string>()),
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data: results,
    rowCount: count,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    enableEditing: false,
    renderDetailPanel: ({ row }) => (
              <Box sx={{ padding: '1rem' }}>
                {/*<ListaMonitorProgettiNodiInline codprogprop={row.original.CODPROG.trim()} />*/}
              </Box>
            ),
    enableExpandAll: false,
    enableExpanding: true,
    initialState: {
      density: 'compact',
    },
    muiTableBodyCellProps: {
      sx: {
        padding: '4px',
        fontSize: '0.75rem',
      },
    },
    muiTableHeadCellProps: {
      sx: {
        padding: '4px',
        fontSize: '0.75rem',
      },
    },
    muiTableContainerProps: {
      sx: {
        minHeight: '400px',
      },
    },
    muiToolbarAlertBannerProps: isError
      ? { color: 'error', children: 'Error loading data' }
      : undefined,

    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,

    renderTopToolbarCustomActions: ({ table }) => (

    <Box
        sx={{
          display: 'flex',
          gap: '16px',
          padding: '8px',
          flexWrap: 'wrap',
            // border: '2px solid red',
        }}
      >

       {/*<Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1rem' }}> Nodi Progetto </Typography>*/}

      {/*<Button onClick={() => setIsDialogExporterOpen(true)} startIcon={<FileDownloadIcon />} > EXPORT DATI </Button>*/}
      {/*  {isDialogExporterOpen && (*/}
      {/*      <ReportClientiVersoreExp*/}
      {/*        pagination={pagination}*/}
      {/*        columnFilters={columnFilters}*/}
      {/*        globalFilter={globalFilter}*/}
      {/*        sorting={sorting}*/}
      {/*        onClose={() => setIsDialogExporterOpen(false)}*/}
      {/*      />*/}
      {/*    )}*/}


          {/*<Button onClick={() => setIsDialogReportClientiVersoreXLS(true)} startIcon={<TableRowsIcon />}>*/}
          {/*  Report Ore Clienti XLS*/}
          {/*</Button>*/}
          {/*{isDialogReportClientiVersoreExpXLS && <ReportClientiVersoreJasper propditta={storeDitta} propcodcli={storeCodCli}   propformato="xlsx" onClose={() => setIsDialogReportClientiVersoreXLS(false)} />}*/}

          {/*<Button onClick={() => setIsDialogReportClientiVersorePDF(true)} startIcon={<PictureAsPdfIcon />}>*/}
          {/*  Report Ore Clienti PDF*/}
          {/*</Button>*/}
          {/*{isDialogReportClientiVersoreExpPDF && <ReportClientiVersoreJasper propditta={storeDitta} propcodcli={storeCodCli}  propformato="pdf" onClose={() => setIsDialogReportClientiVersorePDF(false)} />}*/}

   </Box>
   ),




    state: {
      isLoading,
      showProgressBars: isFetching,
      showAlertBanner: isError,
      columnFilters,
      globalFilter,
      pagination,
      sorting,
    },
  });

  return (

       <Dialog onClose={onClose} open fullWidth maxWidth="xl">
        <Box display="flex" flexDirection="column" height="150vh">
          <Box display="flex" justifyContent="space-between" alignItems="center" p={1}>
          <Typography variant="h6" fontWeight="bold" color="primary">
            NODI PROGETTO    {desprogprop}
          </Typography>
          <Button variant="contained" onClick={onClose} color="error" size="small">
            CHIUDI
          </Button>
        </Box>

        {/* Dashboard embed */}
        <DialogContent style={{ flex: 1, padding: 0 }}>
          <MaterialReactTable table={table} />
        </DialogContent>
      </Box>
    </Dialog>






  );
};

export default ListaMonitorProgettiNodi;
